import { plans } from "../data/pricingModal";

/**
 * Map API / DB package labels (e.g. "40 Credits") onto product plan names.
 * Credit packs / free → "Pay as you go". Paid subs → Lite | Pro | Max.
 */
export const mapProductPlanName = (name, credits = null) => {
  const raw = String(name || "")
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!raw) return "Pay as you go";
  if (/pay\s*as\s*you\s*go/i.test(raw)) return "Pay as you go";

  const named = raw.match(/\b(lite|pro|max)\b/i);
  if (named) {
    const key = named[1].toLowerCase();
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  let count = Number(credits);
  if (!Number.isFinite(count) || count <= 0) {
    const match = raw.match(/(\d[\d,]*)\s*credits?/i);
    if (match) count = Number(String(match[1]).replace(/,/g, ""));
  }

  if (!Number.isFinite(count) || count <= 0) {
    return raw;
  }

  for (const plan of plans) {
    const tierCredits = [
      Number(plan.credits),
      ...(plan.creditTiers || []).map((tier) => Number(tier.credits)),
    ].filter((value) => Number.isFinite(value));
    if (tierCredits.includes(count)) return plan.name;
  }

  const liteCap = Math.max(
    0,
    ...((plans.find((plan) => plan.name === "Lite")?.creditTiers || []).map(
      (tier) => Number(tier.credits)
    ) || [200])
  );
  const proCap = Math.max(
    0,
    ...((plans.find((plan) => plan.name === "Pro")?.creditTiers || []).map(
      (tier) => Number(tier.credits)
    ) || [2500])
  );

  if (count <= liteCap) return "Lite";
  if (count <= proCap) return "Pro";
  return "Max";
};
